import { BadgeButton } from "src/components/base/badge";
import { LinkIcon } from "@heroicons/react/20/solid";

/**
 * The properties for {@link DeviceLinkBadge}
 */
export type DeviceLinkBadgeProps = {
    /**
     * The device this badge links to
     *
     * The type is intentionally not from the generated sdk
     * to support as many callers as possible
     */
    device: { uuid: string; name: string };

    /** Additional classname to set */
    className?: string;

    /**
     * A `<DeviceLinkBadge />` is a link to the device's page.
     * This optional argument overwrites this link's default target.
     */
    target?: "_blank" | "_parent" | "_self" | "_top";
};

/** A neutral badge with a link icon, linking to the device's page */
export function DeviceLinkBadge(props: DeviceLinkBadgeProps) {
    const { device, className, target } = props;

    return (
        <BadgeButton
            className={className}
            color={"zinc"}
            target={target}
            href={"/a/devices/$deviceId/general"}
            params={{ deviceId: device.uuid }}
        >
            <LinkIcon className={"w-4"} />
            <span>{device.name}</span>
        </BadgeButton>
    );
}
